export enum ItemLocation {
  UNKNOWN = 1,
  IN_STOCK = 2,
  SOLD = 3,
  IN_TRANSIT = 4,
  STOLEN = 5
}
